export const NAVBAR_HEIGHT = 64
export const HEADER_HEIGHT = 80
export const FOOTER_HEIGHT = 72
export const PADDINGS = 180
export const tableHeight = window.innerHeight - (NAVBAR_HEIGHT + HEADER_HEIGHT + FOOTER_HEIGHT + PADDINGS)
